var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotTableDeleteGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 4.53516H15.4588L15.0874 3.4216C14.8537 2.72086 14.2003 2.25 13.4617 2.25H10.5383C9.79962 2.25 9.14634 2.72086 8.91203 3.4216L8.54111 4.53516H5.14453C4.19947 4.53516 3.43066 5.30396 3.43066 6.24902V7.3916C3.43066 8.02794 4.00351 7.96289 4.6183 7.96289C9.89526 7.96289 14.6797 7.96289 19.998 7.96289C20.3138 7.96289 20.5693 7.70737 20.5693 7.3916V6.24902C20.5693 5.30396 19.8005 4.53516 18.8555 4.53516ZM9.74581 4.53516L9.99603 3.78311C10.0741 3.54934 10.2923 3.39258 10.5383 3.39258H13.4617C13.7077 3.39258 13.9259 3.54934 14.0034 3.78311L14.2539 4.53516H9.74581Z",
    fill: "url(#paint0_linear_2721_9657)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71287 9.18164L5.62377 20.1912C5.70467 21.0799 6.43832 21.75 7.3304 21.75H16.6696C17.5617 21.75 18.2954 21.0799 18.3768 20.1862L19.2872 9.18164H4.71287ZM9.14356 18.8935C9.14356 19.6466 8.00098 19.6497 8.00098 18.8935V10.8955C8.00098 10.1424 9.14356 10.1393 9.14356 10.8955V18.8935ZM12.5713 18.8935C12.5713 19.6466 11.4287 19.6497 11.4287 18.8935V10.8955C11.4287 10.1424 12.5713 10.1393 12.5713 10.8955V18.8935ZM15.999 18.8935C15.999 19.6466 14.8565 19.6497 14.8565 18.8935V10.8955C14.8565 10.5797 15.112 10.3242 15.4277 10.3242C15.7435 10.3242 15.999 10.5797 15.999 10.8955V18.8935Z",
    fill: "url(#paint1_linear_2721_9657)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2721_9657",
    x1: 3.43066,
    y1: 12.0007,
    x2: 20.5693,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2721_9657",
    x1: 3.43066,
    y1: 12.0007,
    x2: 20.5693,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotTableDeleteGold);
export default __webpack_public_path__ + "static/media/Bot_Table_Delete_Gold.f3c8611e2715ccee3bcac5bac742fdf7.svg";
export { ForwardRef as ReactComponent };